import { StrictMode } from 'react';
import { render } from 'react-dom';
import TagManager from 'react-gtm-module';

import App from './components/App';
import './i18n';

if (process.env.NODE_ENV !== 'development') {
  TagManager.initialize({
    gtmId: process.env.REACT_APP_GTM_ID as string,
    auth: process.env.REACT_APP_GTM_AUTH,
    preview: process.env.REACT_APP_GTM_ENV,
  });
}

render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root'),
);
